import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContentLayoutComponent } from './layout/content-layout/content-layout.component';

const routes: Routes = [
  
  { path: '', pathMatch: 'full', redirectTo: 'onboarding' },
  {
    path: '',
    component: ContentLayoutComponent,
    children: [
      {
        path: 'onboarding',
        loadChildren: () =>
          import('./modules/onboarding/onboarding.module').then(m => m.OnboardingModule)
      },
      {
        path: 'welcome',
        loadChildren: () =>
          import('./modules/welcome/welcome.module').then(m => m.WelcomeModule)
      },
    ]
  },
  {
    path: 'shopping-cart-ext',
    loadChildren: () =>
      import('./modules/shopping-cart-ext/shopping-cart-ext.module').then(m => m.ShoppingCartExtModule)
  },
  {
    path: 'error',
    loadChildren: () =>
      import('./modules/error/error.module').then(m => m.ErrorModule)
  },
  {
    path: '**',
    redirectTo: 'error/PageNotFound'
  }
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
